import boards from './boards';
import core from './core';

export default {
  ...boards,
  ...core,
};
